// extracted by mini-css-extract-plugin
export default {"container":"ChipView_container__frx7y","titleText":"ChipView_titleText__3kV+G"};